import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  MenuItem,
  Typography,
} from "@mui/material";

const MoveBookmarkDialog = ({
  open,
  onClose,
  onConfirm,
  groups,
  currentGroupId,
  targetGroupId,
  onTargetGroupChange,
  bookmarkAlreadyExists,
}) => {
  const availableGroups = groups?.filter((g) => g._id !== currentGroupId) || [];

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          width: 400,
          borderRadius: "16px",
          padding: "12px",
          background: "#fff",
          boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
        },
      }}
    >
      <DialogTitle
        sx={{
          fontSize: { xs: "16px", md: "18px" },
          color: "#303f9f",
          fontWeight: "bold",
          borderBottom: "1px solid #e0e0e0",
          paddingBottom: "12px",
        }}
      >
        Copy to Another Group
      </DialogTitle>
      <DialogContent
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          marginTop: "20px",
          padding: "12px",
        }}
      >
        <TextField
          label="Select Group"
          variant="outlined"
          select
          fullWidth
          disabled={availableGroups.length === 0}
          size="small"
          value={targetGroupId}
          onChange={(e) => onTargetGroupChange(e.target.value)}
          sx={{ mt: 1 }}
          InputProps={{
            sx: {
              bgcolor: "white",
              fontSize: "13px",
              "& input:-webkit-autofill": {
                backgroundColor: "white !important",
                WebkitBoxShadow: "0 0 0 30px white inset !important",
                WebkitTextFillColor: "black !important",
              },
            },
          }}
          InputLabelProps={{ sx: { fontSize: "13px" } }}
        >
          {availableGroups.map((group) => (
            <MenuItem
              key={group._id}
              value={group._id}
              sx={{
                fontSize: "13px",
                maxWidth: "400px",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }}
            >
              {group.groupName}
            </MenuItem>
          ))}
        </TextField>

        {availableGroups.length === 0 && (
          <Typography textAlign="center" sx={{ color: "#757575", fontSize: "13px", mt: 2 }}>
            No other groups available. Please create a new group to copy this bookmark.
          </Typography>
        )}

        {bookmarkAlreadyExists && (
          <Typography textAlign="center" sx={{ color: "#757575", fontSize: "13px", mt: 2 }}>
            Bookmark already exists in the selected group.
          </Typography>
        )}
      </DialogContent>
      <DialogActions sx={{ justifyContent: "flex-end", padding: "12px" }}>
        <Button
          onClick={onClose}
          color="primary"
          variant="outlined"
          sx={{
            borderRadius: "24px",
            fontSize: { xs: "13px", md: "14px" },
            padding: "8px 24px",
            textTransform: "none",
            fontWeight: "bold",
          }}
        >
          Cancel
        </Button>
        <Button
          onClick={onConfirm}
          color="primary"
          variant="contained"
          disabled={availableGroups.length === 0 || bookmarkAlreadyExists}
          sx={{
            borderRadius: "24px",
            fontSize: { xs: "13px", md: "14px" },
            padding: "8px 24px",
            textTransform: "none",
            fontWeight: "bold",
            ml: 2,
          }}
        >
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default MoveBookmarkDialog;
